import React, { ReactElement } from 'react';
import { Table } from 'antd';

import { useBreedersContext } from 'dogpark/context';
import { testId } from 'dogpark/utilities/test/datatestId';
import { BreedersColumnActiveStatus } from './breedersTableColumns';

function BreedersTable(): ReactElement {
  const {
    state: { breeders, loading },
  } = useBreedersContext();
  return (
    <Table
      data-testid={testId.breedersTable}
      loading={loading}
      dataSource={breeders}
      rowKey={(breeder) => breeder.id}
      scroll={{ x: true }}
      columns={[
        {
          title: 'ID',
          dataIndex: 'id',
        },
        {
          title: 'First',
          dataIndex: 'users',
          key: 'firstName',
          render: (users) => users[0]?.firstName,
        },
        {
          title: 'Last',
          dataIndex: 'users',
          key: 'lastName',
          render: (users) => users[0]?.lastName,
        },
        {
          title: 'Email',
          dataIndex: 'users',
          key: 'email',
          render: (users) => users[0]?.email,
        },
        {
          title: 'Status',
          key: 'activeStatus',
          render: (breeder) => <BreedersColumnActiveStatus breeder={breeder} />,
        },
      ]}
      pagination={{
        hideOnSinglePage: true,
        pageSize: 100,
      }}
    />
  );
}

export default BreedersTable;
